import { useMutation } from "@tanstack/react-query";

import { delay } from "../../../utils";
import { queryClient } from "../../queryClient";
import { spbTransferAPI } from "../spbTransferAPI";

const POLL_INTERVAL_MS = 1000; // 1сек
const MAX_TOTAL_TIME_MS = 6000; // 6сек

export const useMakeSbpTransferMutation = () => {
  return useMutation ({
    mutationKey: ["make-sbp-transfer"],
    mutationFn: async ({
      amount,
      bankId,
      trancheProductCode,
    }: { amount: string; bankId: string; trancheProductCode: string }) => {
      const creatingTransferRes
          = await spbTransferAPI.makeTransfer({ amount, bankId, trancheProductCode });

      const creditorTrancheId = creatingTransferRes.creditorTrancheId;
      if (!creditorTrancheId) {
        throw new Error("Creditor tranche ID is undefined");
      }

      const pollingStartTime = Date.now();
      let transferPollingRes = await spbTransferAPI.makeTransferPolling(creditorTrancheId);

      while (transferPollingRes.statusCode === "IN_PROGRESS") {
        const timePassed = Date.now() - pollingStartTime;

        if (timePassed > MAX_TOTAL_TIME_MS) {
          return transferPollingRes;
        }

        await delay(POLL_INTERVAL_MS);
        transferPollingRes = await spbTransferAPI.makeTransferPolling(creditorTrancheId);
      }

      if (transferPollingRes.statusCode !== "DONE" && transferPollingRes.statusCode !== "ERROR") {
        throw new Error(`Unexpected status after pooling a sbp transfer result: ${transferPollingRes.statusCode}`);
      }

      return transferPollingRes;
    },
    onSettled: () => {
      void queryClient.invalidateQueries();
    },
  });
};
